var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.isScaning}},[_c('div',{staticClass:"wrapper"},[_c('svg-icon',{staticClass:"delete-icon",attrs:{"icon-class":"delete-icon"},on:{"click":_vm.stopScan}}),_c('div',{staticClass:"qrcode"},[_c('div',{attrs:{"id":"reader"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }